module.exports = __webpack_public_path__ + "static/media/fast-clock-black.1ccdd1c2.svg";